import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getEventsQuery($propertyId: ID!, $startAt: String, $endAt: String, $status: String, $search: String,$last:Int,$before:String,$type:String) {
    hyevents(propertyId: $propertyId, startAt: $startAt, endAt: $endAt, status: $status, search: $search,last:$last,before:$before,type:$type) {
      pageInfo {
        endCursor
        startCursor
        hasPreviousPage
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          title
          maxNoOfGuests
          additionalGuestAllowed
          maxAdditionalGuests
          ctaText
          messageTitle
          message
          address
          placeName
          status
          propertyId
          startAt
          endAt
          publishAt
          inviteScheduledAt
          cancelReason
          rsvpedCount
          inviteEmailCampaignId
          cancelEmailCampaignId
          rescheduleEmailCampaignId
          nightReminderEmailCampaignId
          morningReminderEmailCampaignId
          rsvpedCampaignId
          rsvpCancelledCampaignId
          waitlistedCampaignId
          waitlistOpeningCampaignId
          image{
            id
            fileType
            fileSize
            fileUrl
            dimension
            thumbnailUrl
          }
          eventType
          displayTime
          zoomLink
          meetingId
          passcode
          smsEnabled
          recurringEventType
          invitedGroups
        }
      }
    }
  }
`;
